const _ = require('lodash');
const _store = {};
function StorePickerService(Restangular, $rootScope, settingsService, ShopLocatorService, LocalStorageService, dynamicContentService, productGroupCarouselService, $timeout) {
    this._api = Restangular.one('Address');
    this._localStorage = LocalStorageService;
    this.$rootScope = $rootScope;
    this.settingsService = settingsService;
    this.shopLocatorService = ShopLocatorService;
    this.delivery = { allowed: false };
    this.isSettingStore = false;
    this.isInitialised = false;
    this.fulfilmentInfo = { FulfilmentMethod: 'Pick Up' };
    this.dynamicContentService = dynamicContentService;
    this.productGroupCarouselService = productGroupCarouselService;
    this.$timeout = $timeout;
    this.isFirstLoad = true;
    Object.defineProperty(this, 'store', {
        enumerable: true,
        get() {
            return _store;
        },
        set(newStoreValue) {
            _.assign(_store, newStoreValue);
        }
    });

    this.init();
}

const cleanStore = function () {
    return {
        AddressCity: '',
        AddressCountry: '',
        AddressId: '',
        AddressPostalCode: '',
        AddressStreet1: '',
        AddressSuburb: '',
        AddressSuburbID: '',
        FulfilmentStoreID: '',
        FulfilmentStoreId: '',
        PostCode: '',
        SuburbName: '',
        SuburbStateString: ''
    };
};

StorePickerService.prototype.bindFulfilmentInfo = function (data) {
    const isDeliveryAllowed = data.FulfilmentMethod === 'Delivery' && this.delivery.allowed;
    this.fulfilmentInfo = data;

    //Transforming fulfilment method to 'Pickup' due to rebranding update (no API updates required)
    if (this.fulfilmentInfo.FulfilmentMethod === 'Click & Collect') {
        this.fulfilmentInfo.FulfilmentMethod = 'Pick Up';
    }
    this.fulfilmentMethod = isDeliveryAllowed ? 'Delivery' : 'Pick Up';
    this.store = cleanStore();
    this.store = isDeliveryAllowed ? data.DeliveryDetails : data.ClickAndCollectDetails;
    this.store.IsClosed = this.isStoreClosed(this.store);
    this.setFulfilmentInfoInLocalStorage(data);
    this.$rootScope.$broadcast('store:update', data);
    this.$rootScope.$broadcast('store:updated', { isFirstLoad: this.isFirstLoad });
    this.$rootScope.$broadcast('trolley:invalidatePricing');

    if (!this.isFirstLoad) {
        this.dynamicContentService.invalidateCache();
    }

    //invalidate the carousal cache on home page when store is updated.
    this.productGroupCarouselService.invalidate();

    this.isFirstLoad = false;
    return data;
};

StorePickerService.prototype.init = function () {
    //If Fulfilment info is in local storage set the store from there
    //Otherwise get the System or saved address

    this.settingsService.getSettingValue('Delivery', 'AllowDeliveries').then((isDeliveryEnabled) => {
        this.delivery.allowed = isDeliveryEnabled;
        this.getFulFilmentInfo();
        this.isInitialised = true;
    });
};

StorePickerService.prototype.setStore = function (type) {

    const isPickup = type === 'Pick Up';

    const storeId = isPickup ? this.fulfilmentInfo.ClickAndCollectDetails.FulfilmentStoreID
        : this.fulfilmentInfo.DeliveryDetails.FulfilmentStoreID;

    const callback = isPickup ? this.setPickupByStoreNo.bind(this)
        : this.setDeliveryByStoreNo.bind(this);

    return callback(storeId);
};

StorePickerService.prototype.setFulfilmentInfoInLocalStorage = function (fulfilmentInfo) {
    //Check to make sure the address is not a system address before saving to local storage
    if (!fulfilmentInfo.IsSystemAddress) {
        const fulfilmentInfoString = JSON.stringify(fulfilmentInfo);
        //store fulfilment info in local storage
        this._localStorage.setItem('fulfilmentInfo', fulfilmentInfoString);
    }
};
StorePickerService.prototype.getFulFilmentInfo = function () {
    const that = this;
    const fulfilmentInfo = that.settingsService.getPageModelData('FulfilmentInfo') || null;

    //call backend when
    //1. non-firstLaod.
    //2. PageModel.FulfilmentInfo not found during firstLoad.
    if (!that.isFirstLoad || fulfilmentInfo == null) {
        return that._api.one('FulfilmentInfo').get().then((FulfilmentInfo) => {
            that.bindFulfilmentInfo(FulfilmentInfo);
        });
    }

    //found PageModel.FulfilmentInfo during firstLoad.
    if (that.isFirstLoad && fulfilmentInfo != null) {
        //MUST be async to cater watchers.
        return that.$timeout(null, 0).then(function () {
            that.bindFulfilmentInfo(fulfilmentInfo);
        });
    }
};

StorePickerService.prototype.isDelivery = function () {

    return this.fulfilmentInfo.FulfilmentMethod === 'Delivery';
};

StorePickerService.prototype.isStoreClosed = function (store) {
    if (!store || !store.TradingHours) {
        return true;
    }

    const todayTrading = store.TradingHours.find(x => x.Day === 'Today');
    const tradingHours = todayTrading ? todayTrading.OpenHour : undefined;

    if (tradingHours.toLowerCase() === 'closed') {
        return true;
    }

    const tradingHoursArray = tradingHours ? tradingHours.split('-') : [];
    if (tradingHoursArray.length < 1) {
        return true;
    }

    const now = new Date();
    const closeAt = `${now.getMonth() + 1}/${now.getDate()}/${now.getFullYear()} ${tradingHoursArray[1].trim().toLowerCase()}`; // eg: 10/21/2023 9:00 pm

    const closeAtTs = new Date(closeAt).getTime();
    const nowTs = now.getTime();

    return nowTs > closeAtTs;
};

StorePickerService.prototype.nextTradingHourMessage = function (store) {
    if (!store || !store.IsClosed) return '';
    const nextTradingDays = store.TradingHours && store.TradingHours.length ? store.TradingHours.filter(x => x.Day !== 'Today' && x.OpenHour.toLowerCase() !== 'closed') : [];
    const nextTradingDay = nextTradingDays.length > 0 ? nextTradingDays[0] : null;
    return nextTradingDay ? `Open ${nextTradingDay.Day === 'Tomorrow' ? 'tomorrow' : nextTradingDay.Day } ${nextTradingDay.OpenHour.toLowerCase()}` : '';
};

/**
 * Sets pickup by store number
 * @param storeNo
 */
StorePickerService.prototype.setPickupByStoreNo = function (storeNo) {

    return this._api.post('SetPickupByStoreNo', { StoreNo: storeNo })
        .then((response) => { return this.bindFulfilmentInfo(response.FulfilmentInfo); });
};

/**
 * Sets Delivery by postcode and suburb
 * @param postcode
 * @param suburb
 */
StorePickerService.prototype.setDeliveryByPostcodeAndSuburb = function (postcode, suburb) {
    return this._api.post('SetDeliveryByPostcodeAndSuburb', {
        Postcode: postcode,
        Suburb: suburb
    }).then((response) => { return this.bindFulfilmentInfo(response.FulfilmentInfo); });
};

/**
 * Sets Delivery by store number
 * @param storeNo
 * @returns {Promise<T>|*}
 */
StorePickerService.prototype.setDeliveryByStoreNo = function (storeNo) {
    return this._api.post('SetDeliveryByStoreNo', { StoreNo: storeNo })
        .then((response) => { this.bindFulfilmentInfo(response.FulfilmentInfo); });
};

/**
 * Find Delivery by store number
 * @param storeNo
 * @returns {Promise<T>|*}
 */
StorePickerService.prototype.findDeliveryByStoreNo = function (storeNo) {
    return this._api.post('SetDeliveryByStoreNo', { StoreNo: storeNo })
        .then(() => { });
};

/**
 * Calculates the stores availability message
 * @param store
 * @param verbose
 * @returns {*}
 */

StorePickerService.prototype.findItemAvailabilityMessage = function (store, verbose) {
    let availabilityMessage;

    if (store.UnavailableItems === 0) {
        availabilityMessage = `All items ${verbose ? 'in cart ' : ''}available`;
    } else if (store.UnavailableItems === store.TotalItemsInCart) {
        availabilityMessage = `All items ${verbose ? 'in cart ' : ''}unavailable`;
    } else if (store.UnavailableItems !== 0 && store.UnavailableItems !== store.TotalItemsInCart) {
        availabilityMessage = `${store.AvailableItems} of ${store.TotalItemsInCart}${(verbose ? ' items in cart' : '')} available`;
    }

    return availabilityMessage;
};

module.exports = StorePickerService;



/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/storepicker/store-picker-service.js
 **/